let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("chujL")).then(() => parcelRequire('4GFkJ'));